export default "__VITE_ASSET__BXRdtblI__"